export const arrayChunk = (arr = [], size) =>{
    const chunkedArray = Array.from({length: Math.ceil(arr.length / size)}, (v, i) => arr.slice(i * size, i * size + size));
    return chunkedArray;
}